import store from '@/store'
import _ from 'lodash'
import compare from '@/utils/compareUtils'

const $ConfirmDiscardOnLeaveDefaultMessage = '変更を破棄しますか？'
export default {
  data () {
    return {
      $_ConfirmDiscardOnLeave_watchTarget: {},
      $_ConfirmDiscardOnLeave_original: {},
      $_ConfirmDiscardOnLeave_watching: false,
      $_ConfirmDiscardOnLeave_dialogShown: false,
      $_ConfirmDiscardOnLeave_message: ''
    }
  },
  created () {
    this.$_ConfirmDiscardOnLeave_watchTarget = {}
    this.$_ConfirmDiscardOnLeave_original = {}
    this.$_ConfirmDiscardOnLeave_watching = false
    this.$_ConfirmDiscardOnLeave_dialogShown = false
  },
  methods: {
    $_ConfirmDiscardOnLeave_watchStart (target, message = $ConfirmDiscardOnLeaveDefaultMessage) {
      this.$_ConfirmDiscardOnLeave_watchTarget = target
      this.$_ConfirmDiscardOnLeave_original = _.cloneDeep(target)
      this.$_ConfirmDiscardOnLeave_watching = true
      this.$_ConfirmDiscardOnLeave_message = message
    },
    $_ConfirmDiscardOnLeave_watchEnd () {
      this.$_ConfirmDiscardOnLeave_watchTarget = {}
      this.$_ConfirmDiscardOnLeave_original = {}
      this.$_ConfirmDiscardOnLeave_watching = false
    },
    $_ConfirmDiscardOnLeave_isChanged () {
      return this.$_ConfirmDiscardOnLeave_watching &&
        !compare.compare(this.$_ConfirmDiscardOnLeave_original, this.$_ConfirmDiscardOnLeave_watchTarget)
    },
    /**
     * ダイアログを表示する.
     * すでにダイアログが表示されている場合、Error('shown') でrejectする.
     */
    $_ConfirmDiscardOnLeave_showDialogIfNeed () {
      if (this.$_ConfirmDiscardOnLeave_dialogShown) {
        return Promise.reject(Error('shown'))
      }
      if (this.$_ConfirmDiscardOnLeave_isChanged()) {
        this.$_ConfirmDiscardOnLeave_dialogShown = true
        return this.$confirm(this.$_ConfirmDiscardOnLeave_message, 'Warning', {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            this.$_ConfirmDiscardOnLeave_dialogShown = false
            done()
          }
        })
      } else {
        return Promise.resolve()
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$log.debug('beforeRouteUpdate')
    this.$_ConfirmDiscardOnLeave_showDialogIfNeed()
      .then(() => next())
      .catch(() => next(false))
  },
  beforeRouteLeave (to, from, next) {
    this.$log.debug('beforeRouteLeave')
    // トークンチェックで事前にログインフラグが更新されている場合は確認ダイアログを表示しない
    if (store.state.loggedIn) {
      this.$_ConfirmDiscardOnLeave_showDialogIfNeed()
        .then(() => next())
        .catch(() => next(false))
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/confirmDiscardOnLeave.js